(() => {
  document.querySelectorAll('.charging-calculator-form').forEach(form => {
    const total = form.querySelector('.calculator-total');
    const detail = form.querySelector('.calculator-detail');
    function update() {
      const energy = form.elements.energy.valueAsNumber;
      const rate = form.elements.rate.valueAsNumber / 100;
      const efficiency = form.elements.efficiency.valueAsNumber;
      if (!form.checkValidity() || ![energy, rate, efficiency].every(Number.isFinite)) {
        total.value = '—';
        detail.textContent = 'Enter valid values in all three fields.';
        return;
      }
      const wallEnergy = energy / (efficiency / 100);
      total.value = '$' + (wallEnergy * rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      detail.textContent = `Estimated electricity cost · ${wallEnergy.toFixed(1)} kWh from the wall`;
    }
    form.addEventListener('input', update);
    form.addEventListener('submit', event => { event.preventDefault(); update(); });
    update();
  });
})();
